export default {"src":"/_next/static/media/home.bb8ea2f3.svg","height":38,"width":48};